import UserDetailsView from "../view/view";
import {connect} from "react-redux";
import {UserDetailsActions} from "../actions/table_actions";
import { RootState } from "../../../app/store";
import { Dispatch } from '@reduxjs/toolkit';
import {requestDataFromAPI, requestUserUpdateFromAPI, requestUserCLientListFromAPI, requestUserNotCLientListFromAPI, requestClientToogle} from "../thunk/table_tunc";
import {deactivateUserFromAPI, deleteUserFromAPI} from "../../UserTableThingy/thunk/table_tunc";
import {LocalProps} from '../view/view';

interface OwnProps {
    id:string;
    uuid:string;
}

const mapStateToProps = (state:RootState, ownProps:OwnProps & {match:any}) => {  
    const myprops=
    {
        userdetails:state.UserDetails.model.user,
        usermandanten:state.UserDetails.model.mandantenlist,
        listmandanten:state.UserDetails.model.listmandanten,
        loadeduuid:ownProps.match.params.uuid,
        loaded:state.UserDetails.view.loaded,
        key: 'tab1',
        importantMapType:state.UserDetails,
    }
    return myprops;
}

  function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps & {match:any}){
      return {
        onLoadRequested:(uuid:string)=>{ 
            dispatch(requestDataFromAPI(uuid) as any);
        },
        deactivateUser:(uuid:string)=>{ 
            dispatch(deactivateUserFromAPI(uuid) as any);
        },
        deleteUser:(uuid:string)=>{ 
            dispatch(deleteUserFromAPI(uuid) as any);
        },
        onConfigChange:(data:any, type:string)=>{
            console.log(data,type);
            const action = UserDetailsActions.SetUserDetail({data:data, type});
            console.log(action);
            dispatch(action);
            console.log("Parameter SET -> DONE");
        },
        CopyUserToNew:(data:any) => {
            dispatch(UserDetailsActions.CopyUserToNew({data:data}))
        },
        requestUserUpdateFromAPI:(data:any, uuid:any) => {
            (requestUserUpdateFromAPI(data, uuid)  as any)(dispatch)
        },
        requestUserCLientListFromAPI:(uuid:any) => {
            (requestUserCLientListFromAPI(uuid)  as any)(dispatch)
        },
        requestUserNotCLientListFromAPI:(uuid:any) => {
            (requestUserNotCLientListFromAPI(uuid)  as any)(dispatch)
        },
        requestClientToogle:(uuid:string, useruuid:string, action:string) => {
            (requestClientToogle(uuid, useruuid, action)  as any)(dispatch)
        },
        
      }
  }

  const mergeProps = (
      mapProps:ReturnType<typeof mapStateToProps>, 
      dispatchProps:ReturnType<typeof bindDispatchToActions>,
      ownProps:OwnProps & {match:any}
      ) => {
    
    const mergedProps:LocalProps = 
    {
        userdetails:mapProps.userdetails,
        usermandanten:mapProps.usermandanten,
        listmandanten:mapProps.listmandanten,
        loadeduuid:mapProps.loadeduuid,
        loaded:mapProps.loaded,
        key: 'tab1',

        onLoadRequested:dispatchProps.onLoadRequested,
        requestUserCLientListFromAPI: dispatchProps.requestUserCLientListFromAPI,
        requestUserNotCLientListFromAPI: dispatchProps.requestUserNotCLientListFromAPI,
        requestClientToogle:dispatchProps.requestClientToogle,
        deactivateUser:dispatchProps.deactivateUser,
        deleteUser:dispatchProps.deleteUser,
        onConfigChange:dispatchProps.onConfigChange,

        onSubmit:(data:any, uuid:any)=>{       
          dispatchProps.requestUserUpdateFromAPI(data, uuid); //Data is wrong I need to be merge witrh maprops.changeduserdetails
          console.log("Dispatch should be done");
          // setTimeout(() => {
          //       console.log("Update User Table now");
          //       dispatch(requestDataFromAPI(uuid) as any);
          //   }, 2000);
          
      }
    }
    return mergedProps;
  }

const UserDetailContainer=connect(mapStateToProps, bindDispatchToActions, mergeProps)(UserDetailsView);
export default UserDetailContainer;